import { axios } from "@/lib/axios";

export function apiGetSysConfig() {
    return axios.post( "/api/front/guest/user/config-info" );
}

export function apiGetUserInfo() {
    return axios.post( "/api/front/user/v1/info" );
}

export function apiGetUserContracts( guessNo: string ) {
    return axios.post( "/api/front/guest/user/user-bet-share", { guessNo } );
}

export function apiGetEventChartData( params: {
    eventNo: string;
    timeType: number;
    guessNoList?: string[];
} ) {
    return axios.post( "/api/front/guest/guess-chart-data", params );
}

export function apiGetOtherUserInfo( userId: string | number ) {
    return axios.post( "/api/front/user/other/info", { userId } );
}

export function apiGetActivePayTypeList( params?: { useType?: number } ) {
    return axios.post( "/api/front/pay/type/active/list", params );
}

export function apiGetCardInfo() {
    return axios.post( "/api/front/card/info" );
}

export function apiAddBankCard( params: {
    reqDate?: number;
    versionCode?: number | string;
    channel?: string;
    channelId?: string;
    packageInfo?: string;
    sign?: string;
    packageId?: number;
    lang?: string;
    group?: number;
    ua?: string;
    id?: number;
    cardNumber: string;
    cardName: string;
    email?: string;
    ifsCode: string;
    bankName?: string;
    upiId?: string;
    smsCode?: string;
} ) {
    return axios.post( "/api/front/card/add", params );
}

export function apiUpdateBankCard( params: {
    reqDate?: number;
    versionCode?: number | string;
    channel?: string;
    channelId?: string;
    packageInfo?: string;
    sign?: string;
    packageId?: number;
    lang?: string;
    group?: number;
    ua?: string;
    id: number;
    cardNumber: string;
    cardName: string;
    email?: string;
    ifsCode: string;
    bankName?: string;
    upiId?: string;
    smsCode?: string;
} ) {
    return axios.post( "/api/front/card/update", params );
}

export function apiDeleteBankCard( params: {
    reqDate?: number;
    versionCode?: number | string;
    channel?: string;
    channelId?: string;
    packageInfo?: string;
    sign?: string;
    packageId?: number;
    lang?: string;
    group?: number;
    ua?: string;
    id: number;
    cardNumber: string;
    cardName: string;
    email?: string;
    ifsCode: string;
    bankName?: string;
    upiId?: string;
    smsCode?: string;
} ) {
    return axios.post( "/api/front/card/del", params );
}

export function apiWithdrawPaid( params: {
    reqDate?: number;
    versionCode?: number | string;
    channel?: string;
    channelId?: string;
    packageInfo?: string;
    sign?: string;
    packageId?: number;
    lang?: string;
    group?: number;
    ua?: string;
    price: number;
    cardId: number;
} ) {
    return axios.post( "/api/front/pay/paid", params );
}

export function apiGetWithdrawalFeeSimple() {
    return axios.post( "/api/front/pay/withdrawal/fee" );
}

export function apiGetWithdrawalConfig() {
    return axios.post( "/api/front/pay/config" );
}

export function apiSetTradeVisibility( params: {
    visibilityConfig: any;
} ) {
    return axios.post( "/api/front/user/trade/visibility/set", params );
}

export function apiGetOssCredentials() {
    return axios.post( "/api/front/oss/file/credentials" );
}

export function apiGetDefaultAvatarList() {
    return axios.post( "/api/front/user/getDefaultAvatar" );
}

export function apiUpdateUserInfo( payload: {
    userName?: string;
    userAvatar?: string;
    userDesc?: string;
} ) {
    return axios.post( "/api/front/user/updateInfo", payload );
}

export function apiGetRecommendEvents( id: string | number ) {
    return axios.get( `/api/front/topic/${id}/recommend-events` );
}

export function apiGetHotEvents( params: {
    pageNum?: number;
    pageSize?: number;
} ) {
    const { pageNum = 1, pageSize = 20 } = params;
    return axios.get( "/api/front/event/hot", {
        params: {
            pageNum,
            pageSize,
        },
    } );
}

// Search history related APIs
export function apiGetSearchLogs() {
    return axios.post( "/api/front/user/search/logs/list" );
}

export function apiCreateSearchLog( queryText: string ) {
    return axios.post( "/api/front/user/search/logs/create", { queryText } );
}

export function apiDeleteSearchLog( id: number ) {
    return axios.post( `/api/front/user/search/logs/delete/${id}` );
}

export function apiDeleteRecentSearchLogs() {
    return axios.post( "/api/front/user/search/logs/delete/recent" );
}

export function apiGetUserPnlChart( params: {
    userId: number;
    timeType: string;
} ) {
    return axios.post( "/api/front/user/user-pnl-chart", params );
}
